import { UserModule } from '@/store/modules/user';
import { WorkbenchLayoutModule } from '@/store/modules/workBench';
import { Type } from '@/types/permissionType';
import { checkPermissionCompany, checkPermissionUseAndCompany } from './permission';
const layout: any = [
  {
    'i': '0',
    'x': 0,
    'y': 0,
    'w': 9,
    'h': 6,
    name: '所有工单',
    type: '1',
    isDiy: true,
    permission: ''
  }, {
    'i': '1',
    'x': 9,
    'y': 0,
    'w': 3,
    'h': 2,
    name: '当前版本',
    type: '2',
    isDiy: false,
    permission: ''
  }, {
    'i': '2',
    'x': 9,
    'y': 0,
    'w': 3,
    'h': 4,
    name: '今日点检记录',
    type: '3',
    isDiy: true,
    permission: Type.CHECKPOINT
  },
  {
    'i': '3',
    'x': 0,
    'y': 0,
    'w': 9,
    'h': 4,
    name: '待办工单',
    type: '4',
    isDiy: true,
    permission: ''
  }, {
    'i': '4',
    'x': 9,
    'y': 0,
    'w': 3,
    'h': 4,
    name: '待审核',
    type: '5',
    isDiy: true,
    permission: Type.OrederCheck
  }, {
    'i': '5',
    'x': 0,
    'y': 0,
    'w': 9,
    'h': 4,
    name: '分公司报修 TOP6',
    type: '6',
    isDiy: true,
    permission: Type.BranchCompany
  }, {
    'i': '6',
    'x': 9,
    'y': 0,
    'w': 3,
    'h': 4,
    name: '留言投诉',
    type: '7',
    isDiy: true,
    permission: ''
  }, {
    'i': '7',
    'x': 0,
    'y': 0,
    'w': 9,
    'h': 5,
    name: '服务方统计',
    type: '8',
    isDiy: true,
    permission: ''
  }, {
    'i': '8',
    'x': 9,
    'y': 0,
    'w': 3,
    'h': 2,
    name: '常用功能',
    type: '9',
    isDiy: true,
    permission: Type.REPORT_CREAT + ',' + Type.ROLE_USER + ',' + Type.BRANCH_ORDER_REPORT,
    moduleList: [
      {
        id: 1,
        name: '快速报修',
        permission: Type.REPORT_CREAT,
        show: false,
        isCopanyPermission: true,
        imgUrl: require('@/assets/images/icon-type-spanner.png'),
        jumpUrl: 'order/add'
      },
      {
        id: 2,
        name: '人员管理',
        permission: Type.ROLE_USER,
        show: false,
        isCopanyPermission: true,
        imgUrl: require('@/assets/images/icon-type-user.png'),
        jumpUrl: 'Staff/all'
      },
      {
        id: 3,
        name: '分公司报修单',
        permission: Type.BRANCH_ORDER_REPORT,
        show: false,
        isCopanyPermission: true,
        imgUrl: require('@/assets/images/icon-type-envelope.png'),
        jumpUrl: 'Branch/orderCustomer'
      }
    ]
  }
  // {
  //   'i': '9',
  //   'x': 9,
  //   'y': 0,
  //   'w': 3,
  //   'h': 3,
  //   name: '更新迭代',
  //   type: '10',
  //   isDiy: true,
  //   permission: ''
  // }
];
export function returnLayout() {
  let lLayout:any = [];
  layout.forEach((val:any) => {
    if (val.moduleList && val.moduleList.length > 0) {
      val.moduleList.forEach((val:any) => {
        if (val.permission) {
          if (val.isCopanyPermission) {
            val.show = checkPermissionCompany(UserModule.getCompanyId, parseInt(val.permission));
          } else {
            val.show = checkPermissionUseAndCompany(UserModule.getCompanyId, parseInt(val.permission));
          }
        }
      });
    }
    if (val.permission && checkPermissionCompany(UserModule.getCompanyId, parseInt(val.permission))) {
      lLayout.push(val);
    } else if (!val.permission) {
      lLayout.push(val);
    }
  });
  // WorkbenchLayoutModule.setLayout(lLayout);
  return lLayout;
}
export function returnPamars(layout:any) {
  let pamars:any = {};
  let lLayout:any = layout;
  lLayout.forEach((val:any) => {
    switch (parseInt(val.type)) {
      case 1:
        pamars.is_order_information = 1;
        break;
      case 2:
        pamars.is_company_version_information = 1;
        break;
      case 3:
        pamars.is_cycle_check_information = 1;
        break;
      case 4:
        pamars.is_unfinish_order_information = 1;
        break;
      case 5:
        pamars.is_untreated_check_order_information = 1;
        break;
      case 6:
        pamars.is_branch_company_ranking = 1;
        break;
      case 7:
        pamars.is_order_bbs_information = 1;
        break;
      case 8:
        pamars.is_service_company_statistics = 1;
        break;
      case 9:
        break;
      case 10:
        break;
    }
  });
  return pamars;
}
